import { useState } from "react";
import { Modal } from "react-bootstrap";
import { downloadCustomer } from "../../api/customer";
import { useGroupListHooks } from "../../utils/ProjectsUtilHooks";
import AlertBox from "../AlertBox";
import { BUILDING_STATUS } from "../../tools/userdatatools";
import { useAllPartnersHooks } from "../../utils/project/PartnerUtils";
import OltSelect from "../infrastrucure/olt/OltSelect";

export default function ModalDownloadCustomer({ show, onClose, onSuccess }) {
  let { partners } = useAllPartnersHooks();
  const { projects } = useGroupListHooks();

  const [formFilter, setFormFilter] = useState({
    installation_date_from: "",
    installation_date_until: "",
    is_active: "",
    project_id: "",
    partner_id: "",
    building_ownership_status: "",
    olt_id: "",
  });
  const [alert, setAlert] = useState({ show: false, message: "", type: "" });
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    resetFilter();
    onClose();
  };

  const resetFilter = () => {
    setFormFilter({
      installation_date_from: "",
      installation_date_until: "",
      is_active: "",
      partner_id: "",
      project_id: "",
      building_ownership_status: "",
      // olt_id: "",
    });
  };

  const downloadFile = async () => {
    setLoading(true);

    try {
      let response = await downloadCustomer({ ...formFilter });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Data Pelanggan.xlsx");
      onSuccess("Berhasil mengunduh Data Pelanggan.xlsx");
      document.body.appendChild(link);
      link.click();
      handleClose();
    } catch (error) {
      let message = "Something wrong ... ";

      if (error.response) {
        let { data } = error.response;
        let responseObj = await data.text();
        let responseData = JSON.parse(responseObj);
        message = responseData?.message;
      } else {
        message = "Something Error Happened";
      }

      setAlert({ show: true, message: message, type: "danger" });
    }
    setLoading(false);
  };

  return (
    <Modal show={show} onHide={() => handleClose()} size="md">
      <Modal.Header closeButton>
        <Modal.Title>Download Data Pelanggan</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <AlertBox {...alert} setAlert={setAlert} />

        <form>
          {/* <div className="form-group">
            <label>Tanggal Mulai Paket</label>
            <input type="date" className="form-control" value={formFilter.plan_start} onChange={event => setFormFilter({ ...formFilter, plan_start: event.target.value})} />
          </div>
          <div className="form-group">
            <label>Tanggal Akhir Paket</label>
            <input type="date" className="form-control" value={formFilter.plan_end} onChange={event => setFormFilter({ ...formFilter, plan_end: event.target.value})} />  
          </div> */}
          {/* <div className="form-group">
            <label>Tanggal Aktif Paket Mulai</label>
            <input
              type="date"
              className="form-control"
              value={formFilter.active_from}
              onChange={(event) =>
                setFormFilter({ ...formFilter, active_from: event.target.value })
              }
            />
          </div>
          <div className="form-group">
            <label>Tanggal Aktif Paket Akhir</label>
            <input
              type="date"
              className="form-control"
              value={formFilter.active_until}
              onChange={(event) =>
                setFormFilter({ ...formFilter, active_until: event.target.value })
              }
            />
          </div> */}
          <div className="form-group">
            <label>Tanggal Instalasi Mulai</label>
            <input
              type="date"
              className="form-control"
              value={formFilter.installation_date_from}
              onChange={(event) =>
                setFormFilter({ ...formFilter, installation_date_from: event.target.value })
              }
            />
          </div>
          <div className="form-group">
            <label>Tanggal Instalasi Akhir</label>
            <input
              type="date"
              className="form-control"
              value={formFilter.installation_date_until}
              onChange={(event) =>
                setFormFilter({ ...formFilter, installation_date_until: event.target.value })
              }
            />
          </div>
          <div className="form-group">
            <label htmlFor="statusFilter">Status</label>
            <select
              className="form-control"
              id="statusFilter"
              value={formFilter.is_active}
              onChange={(event) => setFormFilter({ ...formFilter, is_active: event.target.value })}
            >
              <option value="">SEMUA</option>
              <option value="0">Isolir</option>
              <option value="1">Aktif</option>
              <option value="2">Dismantled</option>
              <option value="3">Aktif Trial</option>
              <option value="4">Dismantle Trial</option>
              <option value="5">Deaktivasi Isolir</option>
            </select>
          </div>
          <div className="form-group">
            <label htmlFor="buildingStatusFilter">Status Bangunan</label>
            <select
              className="form-control"
              id="buildingStatusFilter"
              value={formFilter.building_ownership_status}
              onChange={(event) =>
                setFormFilter({ ...formFilter, building_ownership_status: event.target.value })
              }
            >
              <option value="">SEMUA</option>
              {Object.keys(BUILDING_STATUS).map((objKey, index) => (
                <option value={objKey} key={index}>
                  {BUILDING_STATUS[objKey]}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label htmlFor="partnerFilter">Mitra</label>
            <select
              className="form-control"
              id="partnerFilter"
              value={formFilter.partner_id}
              onChange={(event) => setFormFilter({ ...formFilter, partner_id: event.target.value })}
            >
              <option value="">SEMUA</option>
              {partners.map((partner, index) => (
                <option key={index} value={partner.id}>
                  {partner.name}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label htmlFor="projectFilter">Grup/Project</label>
            <select
              className="form-control"
              id="projectFilter"
              value={formFilter.project_id}
              onChange={(event) =>
                setFormFilter((prev) => ({
                  ...prev,
                  project_id: event.target.value,
                  olt_id: "",
                }))
              }
            >
              <option value="">SEMUA</option>
              {projects.map((project, index) => (
                <option value={project.id} key={index}>
                  {project.name}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label htmlFor="oltFilter">OLT</label>
            <OltSelect
              value={formFilter.olt_id}
              project_id={formFilter.project_id}
              onChange={(value) => setFormFilter({ ...formFilter, olt_id: value })}
            />
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-secondary" onClick={() => handleClose()}>
          Close
        </button>
        <button className="btn btn-primary" onClick={() => downloadFile()} disabled={loading}>
          <i className="fas fa-download"></i> {!loading ? "Unduh Data" : "Harap Tunggu ..."}
        </button>
      </Modal.Footer>
    </Modal>
  );
}
